<template>
  <div class="custom-tooltip">
    <el-tooltip
      v-if="text"
      :content="text"
      :disabled="!showTooltip"
      placement="top"
      :effect="effect"
    >
      <div
        class="ellipsis-text"
        :style="{ maxWidth: maxWidth }"
        @mouseenter="handleMouseEnter"
      >
        {{ text }}
      </div>
    </el-tooltip>
    <div v-else>-</div>
  </div>
</template>

<script>
export default {
  name: "EllipsisTooltip",
  props: {
    // 显示的文本
    text: {
      type: String,
      default: "",
    },
    // 最大宽度
    maxWidth: {
      type: String,
      default: "90%",
    },
    // Tooltip 主题
    effect: {
      type: String,
      default: "dark",
    },
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    handleMouseEnter(event) {
      const target = event.target;
      // 判断文本是否超出容器宽度
      this.showTooltip = target.scrollWidth > target.offsetWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tooltip {
  width: 100%;
  .ellipsis-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
